import { Component, Inject, OnInit } from '@angular/core';
import { CategoryModel } from '../../models/category.model';
import { FormGroup } from '@angular/forms';
import { OptionTypeService } from '../../services/option-type.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-add-edit-sponsor-category',
  templateUrl: './add-edit-sponsor-category.component.html',
  styleUrls: ['./add-edit-sponsor-category.component.scss']
})
export class AddEditSponsorCategoryComponent implements OnInit {
 form = new FormGroup({});
  fields: FormlyFieldConfig[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CategoryModel,
    private dialogRef: MatDialogRef<AddEditSponsorCategoryComponent>,
    private service: OptionTypeService) { }

  ngOnInit(): void {
    this.data.type = 'Sponsor';
    this.fields = this.service.buildCategoryForm({ ...this.data });
  }

  save(): void {
    this.dialogRef.close(this.data);
  }

  close(): void {
    this.dialogRef.close(null);
  }

}
